import script from "./QrCodeComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./QrCodeComp.vue?vue&type=script&setup=true&lang=ts"

import "./QrCodeComp.vue?vue&type=style&index=0&id=4be69838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be69838"]])

export default __exports__